"use client";
import React from "react";

interface BillingToggleProps {
  billingCycle: "monthly" | "annually";
  onBillingCycleChange: (cycle: "monthly" | "annually") => void;
}

export function BillingToggle({ billingCycle, onBillingCycleChange }: BillingToggleProps) {
  return (
    <div className="flex flex-col md:flex-row items-center justify-center gap-2">
      <div className="flex border bg-white border-gray-200 rounded-full flex-row gap-1 p-1">
        {/* Monthly Option */}
        <button
          type="button"
          onClick={() => onBillingCycleChange("monthly")}
          className={`rounded-full px-4 py-1.5 text-base font-medium transition-all duration-200
          ${
            billingCycle === "monthly"
              ? "bg-secondary text-white"
              : "text-text-secondary hover:text-secondary"
          }
        `}
        >
          Monthly
        </button>

        {/* Annually Option */}
        <button
          type="button"
          onClick={() => onBillingCycleChange("annually")}
          className={`
            rounded-full px-4 py-1.5 text-base font-medium transition-all duration-200
            ${
              billingCycle === "annually"
                ? "bg-secondary text-white"
                : "text-text-secondary hover:text-secondary"
            }
          `}
        >
          Annually
        </button>
      </div>

      {/* Discount Badge */}

      <div className="bg-primary/5 text-primary-hover text-xs font-medium px-3 py-2 rounded">
        Save 10% on annual plan
      </div>
    </div>
  );
}
